import { useEffect, useState } from "react";
import { api, CATEGORIES } from "@/lib/api";

const Stat = ({ value, label, id }) => (
  <div className="rounded-lg border border-[#2c2f52] bg-gradient-to-b from-[#10132e] to-[#0a0c1e] p-5" data-testid={`stat-${id}`}>
    <b className="block font-display text-3xl text-slate-100">{value ?? "-"}</b>
    <span className="text-xs text-slate-400">{label}</span>
  </div>
);

export default function Overview({ goTab }) {
  const [st, setSt] = useState(null);
  const [news, setNews] = useState([]);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setSt(r.data)).catch(() => setSt({}));
    api.get("/news").then((r) => setNews(r.data.slice(0, 5))).catch(() => {});
  }, []);

  return (
    <div className="space-y-8" data-testid="admin-overview">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat id="online" value={st?.players_online} label="Graczy online" />
        <Stat id="regs" value={st?.registrations_24h} label="Rejestracji (24 h)" />
        <Stat id="files" value={st?.patch_files} label="Plików patcha" />
        <Stat id="news" value={st?.news} label="Newsów" />
        <Stat id="package" value={st?.package ? (st.package.available ? st.package.size_text : "brak") : "-"} label={st?.package?.available ? `Paczka klienta: ${st.package.name}` : "Paczka klienta (wgraj do /opt/koselig2/downloads)"} />
      </div>
      <div>
        <h2 className="font-display text-lg text-amber-100 mb-3">Ostatnie newsy</h2>
        <div className="rounded-lg border border-[#2c2f52] bg-[#0a0c1e] divide-y divide-white/5">
          {!news.length && <p className="p-4 text-sm text-slate-500">Brak newsów.</p>}
          {news.map((n) => (
            <div key={n.id} className="flex items-center gap-4 p-4">
              <span className="text-[10px] tracking-widest px-2 py-0.5 rounded-full bg-[#1d2b50] text-[#9fb2ff]">{CATEGORIES[n.category] || n.category}</span>
              <span className="flex-1 text-sm text-slate-200">{n.title}</span>
              <button onClick={() => goTab("news")} className="btn !min-h-[34px] !px-4 !py-0 !text-[11px] min-w-[90px]">Edytuj</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
